import { enumLoadStatus, LoadStatus } from '@rematter/frontend-lib-api-client';
import { Badge, cn, ThemeColor } from '@rematter/ui-web';

import { useTranslations } from '../../../i18n/useTranslations';

interface OutboundLoadStatusBadgeProps {
  status: LoadStatus;
  size?: 'small' | 'xs' | 'default' | 'large';
  className?: string;
}

const colorByLoadStatus: Record<LoadStatus | string, ThemeColor> = {
  [enumLoadStatus.Unassigned]: 'neutral',
  [enumLoadStatus.Pending]: 'primary',
  [enumLoadStatus.ContainerAtPort]: 'neutral',
  [enumLoadStatus.ContainerInTransit]: 'neutral',
  [enumLoadStatus.ContainerAtFacility]: 'warning',
  [enumLoadStatus.ContainerLoaded]: 'warning',
  [enumLoadStatus.ContainerReturning]: 'neutral',
  [enumLoadStatus.ContainerReadyToShip]: 'primary',
  [enumLoadStatus.Shipped]: 'success',
  [enumLoadStatus.Received]: 'warning',
  [enumLoadStatus.Reconciled]: 'success',
  [enumLoadStatus.Voided]: 'failure',
};

//
// ⚛️ ⚛️ ⚛️ OUTBOUND TICKET STATUS BADGE ⚛️ ⚛️ ⚛️
//
export const OutboundLoadStatusBadge = ({
  status,
  size = 'small',
  className,
}: OutboundLoadStatusBadgeProps) => {
  const t = useTranslations();

  const labelByLoadStatus: Record<LoadStatus | string, string> = {
    [enumLoadStatus.Unassigned]: t.scaleTicketPro.statusUnassigned,
    [enumLoadStatus.Pending]: t.scaleTicketPro.statusPending,
    [enumLoadStatus.ContainerAtPort]: t.scaleTicketPro.statusContainerAtPort,
    [enumLoadStatus.ContainerInTransit]:
      t.scaleTicketPro.statusContainerInTransit,
    [enumLoadStatus.ContainerAtFacility]:
      t.scaleTicketPro.statusContainerAtFacility,
    [enumLoadStatus.ContainerLoaded]: t.scaleTicketPro.statusContainerLoaded,
    [enumLoadStatus.ContainerReturning]:
      t.scaleTicketPro.statusContainerReturning,
    [enumLoadStatus.ContainerReadyToShip]:
      t.scaleTicketPro.statusContainerReadyToShip,
    [enumLoadStatus.Shipped]: t.scaleTicketPro.statusShipped,
    [enumLoadStatus.Received]: t.scaleTicketPro.statusReceived,
    [enumLoadStatus.Reconciled]: t.scaleTicketPro.statusReconciled,
    [enumLoadStatus.Voided]: t.scaleTicketPro.statusVoided,
  };

  return (
    <Badge
      color={colorByLoadStatus[status]}
      size={size}
      className={cn(
        '@OutboundLoadStatusBadge',
        cn('@TicketLoadStatusBadge', className),
      )}
    >
      {labelByLoadStatus[status]}
    </Badge>
  );
};
